import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import styled from 'styled-components'
import flowRight from 'lodash/flowRight'
import { connect } from 'react-redux'
import LKGrid from 'shared/LKGrid'
import { translate } from 'loankeeper-common/helpers'
import { actions as LKModalActions } from 'shared/LKModal'
import { constants, generateDropDownParams, generatePrintPDFUrl } from '../LKPrintButton'

const translateLKM = (name) => translate(`LKMESSAGE-${name}`)

const Container = styled.div`
  position: relative;
  flex: 1;
  height: 100%;

  .text {
    font-size: 12px !important;
    font-family: Noto Serif Regular !important;
  }
  .ui.dropdown .menu {
    border-radius: 0;
    background: #f6f6f6;
    font-family: Noto Serif Regular !important;
    min-width: 200px !important;
    width: 100%;
  }

  .ui.dropdown .menu > .item {
    white-space: pre-wrap !important;
    line-height: 15px;
    display: flex;
    align-items: center;
  }

  .ui.item.simple.dropdown > .menu.transition.dropdown-menu {
    left: calc(100% + 5px);
    top: 0px !important;
    border-radius: 0 !important;
  }

  .ui.simple.dropdown > .menu {
    display: none;
  }

  .ui.simple.active.dropdown > .menu,
  .ui.simple.dropdown:hover > .menu {
    display: block;
  }
  .ui.dropdown .menu > .item:hover {
    background-color: #c7c7c7;
  }
`

const DropdownTitle = styled.div`
  font-weight: bold;
  min-height: 30px;
  line-height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d4eaff !important;
  margin: 5px 0;
  padding: 0 1rem;
`

class LKPrintGrid extends React.Component {
  state = {
    reports: [],
    reportLoading: false,
    reportName: '',
    chooseFormat: false,
    gridWidth: 0,
  }

  //grid error
  onGridReady = (params) => {
    // console.log(params);
    // debugger;
    // this.setState({ gridWidth: params.columnApi.columnController.scrollWidth })
    this.setState({ gridWidth: params.columnApi.scrollWidth })
    if (this.props.onGridReady) {
      this.props.onGridReady(params)
    }
  }

  getContextMenuItems = (params) => {
    if (!this.menuLoading) {
      this.menuX = this.currentPageX
      this.menuY = this.currentPageY
    }

    const items = this.props.getContextMenuItems(params)

    return items.map((item) => {
      let newItem = item

      if (item.printConfig && params) {
        newItem = { ...item, action: this.printAction(item, params) }
        delete newItem.printConfig
      }

      return newItem
    })
  }

  printAction = (item, params) => async () => {
    this.startPrintAction()

    try {
      const contentWidth = 200
      this.showContextMenu(params)

      const rect = document.elementFromPoint(this.pageX, this.pageY).closest('.ag-menu-option')?.getBoundingClientRect()

      this.pageX = rect?.right ?? this.currentPageX
      this.pageY = rect?.top ?? this.currentPageY

      let config = item.printConfig

      if (typeof config === 'function') {
        config = config()

        if (Promise.resolve(config) === config) {
          config = await config
        }
      }

      const { page, type, ID, hash, extraID, extraHash, modalRef, chooseFormat } = config

      if (modalRef) {
        const modalRect = modalRef.ref.current.getBoundingClientRect()

        this.pageX = this.pageX - modalRect.left
        this.pageY = this.pageY - modalRect.top
      }

      if (this.pageX > this.state.gridWidth) {
        this.pageX = this.pageX - contentWidth * 2
      }

      const { Data } = await constants.apis[type]({
        page,
        ...generateDropDownParams(type, { ID, hash, extraID, extraHash }),
      })

      if (!Array.isArray(Data)) return

      if (!chooseFormat && Data.length === 1) {
        const cell = params.api.context.beanWrappers.beans.beanInstance.rowRenderer.rowCtrlsByRowIndex[
          params.node.rowIndex
        ].getCellCtrl(params.column)

        cell.beans.contextMenuFactory.hideActiveMenu()

        this.openReport({
          PrintReportID: Data[0].ID,
          printReportHash: Data[0][constants.hashNames[type]],
          ID,
          hash,
          page,
          type,
          extraID,
          extraHash,
          extraParams: { HashSum_PrintReportIDOID_: Data[0].HashSum_PrintReportIDOID_ },
        })
      } else {
        this.printID = ID
        this.printHash = hash
        this.extraID = extraID
        this.extraHash = extraHash
        this.printPage = page
        this.printType = type

        this.setState({
          reports: Data,
          reportName: item.name,
          chooseFormat,
        })
      }
    } finally {
      this.stopPrintAction()
    }
  }

  startPrintAction = () => {
    document.body.style.cursor = 'wait'
    this.pageX = this.currentPageX
    this.pageY = this.currentPageY

    this.menuLoading = true
  }

  stopPrintAction = () => {
    document.body.style.cursor = ''
    this.menuLoading = false
  }

  showContextMenu = (params) => {
    try {
      const cell = params.api.context.beanWrappers.beans.beanInstance.rowRenderer.rowCtrlsByRowIndex[
        params.node.rowIndex
      ].getCellCtrl(params.column)

      const contextMenuEvent = new MouseEvent('contextmenu', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: this.menuX,
        clientY: this.menuY,
      })

      cell.beans.contextMenuFactory.showMenu(params.node, params.column, params.value, contextMenuEvent)
    } catch (e) {
      console.error(e)
    }
  }

  closeReportMenu = () => {
    this.setState({ reports: [] })
  }

  handleMouseMove = (event) => {
    this.currentPageX = event.pageX
    this.currentPageY = event.pageY
  }

  handleContextMenu = () => {
    this.setState({ reports: [] })
  }

  handleReportOpen = async (_, { value, format }) => {
    this.closeReportMenu()

    const report = this.state.reports.find((r) => r.ID === value)

    this.openReport({
      PrintReportID: value,
      printReportHash: report[constants.hashNames[this.printType]],
      ID: this.printID,
      hash: this.printHash,
      page: this.printPage,
      type: this.printType,
      extraID: this.extraID,
      extraHash: this.extraHash,
      format,
    })
  }

  openReport = async ({
    PrintReportID,
    printReportHash,
    ID,
    hash,
    page,
    type,
    extraID,
    extraHash,
    extraParams,
    format,
  }) => {
    const { openError } = this.props

    this.setState({ reportLoading: true })

    document.body.style.cursor = 'wait'

    try {
      const url = await this.props.generatePrintPDFUrl(
        type,
        {
          ID,
          hash,
          PrintReportID,
          printReportHash,
          page,
          direct: false,
          extraID,
          extraHash,
          extraParams,
          format,
        },
        openError,
      )

      if (url) {
        if (format === 'RTF') {
          window.location = url
        } else {
          window.open(url, '', 'width=900,height=800')
        }
      } else {
        openError(translateLKM('HINT_ERR_TITLE'))
      }
    } finally {
      this.setState({ reportLoading: false })
      document.body.style.cursor = ''
    }
  }

  render() {
    const { chooseFormat, reports, reportLoading, reportName } = this.state

    return (
      <Container onMouseMove={this.handleMouseMove} onContextMenu={this.closeReportMenu} onWheel={this.closeReportMenu}>
        <Dropdown
          style={{ position: 'fixed', zIndex: 10000, left: this.pageX, top: this.pageY }}
          trigger={<span />}
          icon={null}
          open={!!reports.length}
          onClose={this.closeReportMenu}
          value={null}
          onChange={this.handleReportOpen}
          item
        >
          <Dropdown.Menu disabled={reportLoading}>
            <DropdownTitle>
              <Dropdown.Item key={0} disabled value={0} text={reportName} />
            </DropdownTitle>

            {reports.map(({ ID, Title }) =>
              chooseFormat ? (
                <Dropdown item simple text={Title} value={ID}>
                  <Dropdown.Menu className="dropdown-menu">
                    <Dropdown.Item text="RTF ფორმატი" value={ID} format="RTF" onClick={this.handleReportOpen} />
                    <Dropdown.Item text="PDF ფორმატი" value={ID} format="PDF" onClick={this.handleReportOpen} />
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Dropdown.Item
                  key={ID}
                  value={ID}
                  text={Title}
                  disabled={reportLoading}
                  onClick={this.handleReportOpen}
                />
              ),
            )}
          </Dropdown.Menu>
        </Dropdown>

        <LKGrid {...this.props} onGridReady={this.onGridReady} getContextMenuItems={this.getContextMenuItems} />
      </Container>
    )
  }
}

const enhance = flowRight(
  connect(undefined, {
    openError: (message) => LKModalActions.openError(message),
    generatePrintPDFUrl,
  }),
)

export default enhance(LKPrintGrid)
